import { IconProfileProBuyer } from "@/assets/icons/figma/IconProfileProBuyer";
import { InfoLabel } from "@/ui/cva/InfoLabel";

type ProBuyerLabelProps = {
  size: "small" | "medium";
  className?: string;
};

/**
 * The bare green "Pro Buyer" mark (WHO-5948). "Pro Buyer" is a product name
 * and stays untranslated in every locale. Callers decide visibility: the
 * account labels (WHO-5954, AccountLabels) and a sale paid at the Pro Buyer
 * price in Mijn verkopen (WHO-5950).
 */
export const ProBuyerLabel = ({ size, className }: ProBuyerLabelProps) => (
  <InfoLabel
    color="brand"
    variant="light"
    size={size}
    corners="square"
    leftIcon={<IconProfileProBuyer aria-hidden className="size-4 shrink-0" />}
    className={className}
    data-testid="pro-buyer-account-label"
  >
    Pro Buyer
  </InfoLabel>
);
